import React from 'react';
import { useQuery } from '@apollo/client';
import useIntegrationMap from '../../admin/useIntegrationMap';
import LoadingIndicator from '../../components/LoadingIndicator';
import { gql } from '../../graphql/generated';
import SettingsContainerView from '../../settings/SettingsContainerView';
import UserNotificationSettingsTable from './UserNotificationSettingsTable';

const USER_QUERY = gql(/** @complexity 9 */ `
  query UserNotificationSettingsUser {
    currentSession {
      user {
        id
        identities {
          id
          platform
        }
        ...UserNotificationSettingsTable_user
      }
    }
  }
`);

const UserNotificationSettings = () => {
  const { data } = useQuery(USER_QUERY);
  const [integrations] = useIntegrationMap();
  const user = data?.currentSession.user;
  const identities = user?.identities ?? [];

  const isSlackIntegrated = !!integrations.slack;
  const hasSlackIdentity = !!identities.find((i) => i.platform === 'slack');
  const slackConnectUrl = `/settings/identity/connect/slack?redirect_url=${document.location.href}`;

  return (
    <SettingsContainerView
      title="Notifications"
      subtitle={`Choose which notifications you’d like to receive via ${
        isSlackIntegrated ? 'email and in Slack' : 'email'
      }:`}
    >
      {user ? (
        <UserNotificationSettingsTable
          slackConnectUrl={hasSlackIdentity ? null : slackConnectUrl}
          slackIntegrated={isSlackIntegrated}
          user={user}
        />
      ) : (
        <LoadingIndicator />
      )}
    </SettingsContainerView>
  );
};

export default UserNotificationSettings;
